module.exports = __webpack_public_path__ + "img/title-dec.b98e8353.png";